const Data = [
    {
        id:0,
        img:"./Static/maldives.jpg",
        location:"Maldives"
    },
    {
        id:1,
        img:"./Static/borabora2.jpg",
        location:"Germany",
        slide:"./Static/borabora2.jpg",
    },
    {
        id:2,
        img:"./Static/borabora.jpg",
        location:"KeyWest",
        slide:"./Static/borabora.jpg",
    },
    {
        id:3,
        img:"./Static/maldives2.jpg",
        location:"Japan"
    },
    {
        id:4,
        img:"./Static/maldives3.jpg",
        location:"India"
    },
    {
        id:5,
        img:"./Static/keywest.jpg",
        location:"Norway",
        slide:"./Static/keywest.jpg",
    }
]
export default Data;